import {
  ADD_CROPPED_IMAGE,
  REMOVE_CROPPED_IMAGE,
  CLEAR_CROPPED_IMAGES
} from "../actions/types";

const initialState = [];
export default function(state = initialState, action) {
  let croppedImages;
  let uid, urls;
  let result;
  switch (action.type) {
    case ADD_CROPPED_IMAGE: {
      croppedImages = [...state];
      if (croppedImages.length === 1 && croppedImages[0].uid === undefined) {
        croppedImages = [];
      }
      urls = [action.payload.urls[1]];
      uid = action.payload.uid;
      const index = croppedImages.findIndex(image => image.uid === uid);
      if (index !== -1) {
        croppedImages[index].url = urls[0];
        return croppedImages;
      }
      urls.forEach(url => {
        croppedImages.push({
          url,
          uid
        });
      });
      return croppedImages;
    }

    case REMOVE_CROPPED_IMAGE:
      croppedImages = [...state];
      uid = action.payload.uid;
      result = croppedImages.filter(image => image.uid !== uid);
      return result;

    case CLEAR_CROPPED_IMAGES:
      return initialState;
    default:
      return state;
  }
}
